import SimulatorLineup from "../components/simulatorLineup/simulatorLineup";
import { lineupCOLConfig } from "../components/simulatorLineup/configs/lineupCOL.config";

export default function SimulatorLineupCOLPage() {
  return (
    <div className="simulador-page">
      <SimulatorLineup config={lineupCOLConfig} />
    </div>
  );
}
